import {
  CLAUDE_4_5_HAIKU_DEFAULT_MODEL_CONFIG,
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_7_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_4_6_DEFAULT_MODEL_CONFIG,
} from "@app/types/assistant/models/anthropic";
import {
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  FIREWORKS_KIMI_K2_INSTRUCT_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P5_MODEL_CONFIG,
  FIREWORKS_MINIMAX_M2P5_MODEL_CONFIG,
} from "@app/types/assistant/models/fireworks";
import {
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
} from "@app/types/assistant/models/google_ai_studio";
import {
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
} from "@app/types/assistant/models/mistral";
import {
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  GPT_5_5_MODEL_CONFIG,
} from "@app/types/assistant/models/openai";
import type { ModelConfig } from "@app/types/assistant/models/types";
import { GROK_4_MODEL_CONFIG } from "@app/types/assistant/models/xai";

export const USED_MODEL_CONFIGS: readonly ModelConfig[] = [
  GPT_5_5_MODEL_CONFIG,
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  CLAUDE_4_5_HAIKU_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_4_6_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_7_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  FIREWORKS_KIMI_K2_INSTRUCT_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P5_MODEL_CONFIG,
  FIREWORKS_MINIMAX_M2P5_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  GROK_4_MODEL_CONFIG,
] as const;
